import { Link, useLocation } from "react-router-dom";

export const AI_MODULE_GROUPS = {
  relationship: {
    title: "AI关系地图",
    subtitle: "了解自己、理解关系、探索相处",
    tabs: [
      { key: "love", label: "爱情地图", to: "/love-map", hint: "我真正想要什么样的爱情？" },
      { key: "map", label: "关系地图", to: "/ai/relationship-map", hint: "我和TA现在是什么关系？" },
      { key: "sim", label: "关系模拟", to: "/ai/simulation", hint: "如果我们在一起，会发生什么？" },
    ],
  },
  persona: {
    title: "数字人格",
    subtitle: "认识自己，也让 AI 更好地代表你",
    tabs: [
      { key: "personality", label: "AI人格", to: "/ai/personality", hint: "AI 如何理解我？" },
      { key: "twin", label: "数字分身", to: "/ai/twin", hint: "AI 如何代表我？" },
    ],
  },
  advisor: {
    title: "AI婚恋顾问",
    subtitle: "学习沟通，经营关系",
    tabs: [
      { key: "love", label: "恋爱助手", to: "/ai/love-assistant", hint: "怎么认识异性、怎么聊天" },
      { key: "marriage", label: "婚姻顾问", to: "/ai/marriage", hint: "婚前沟通与婚姻经营" },
      { key: "consultant", label: "AI咨询师", to: "/ai/consultant", hint: "统一对话入口" },
    ],
  },
};

export default function AiModuleTabs({ groupKey }) {
  const group = AI_MODULE_GROUPS[groupKey];
  const location = useLocation();
  if (!group) return null;

  return (
    <div className="mb-5">
      <div className="flex flex-wrap items-end justify-between gap-2 mb-3">
        <div>
          <p className="text-xs tracking-wide text-rose-500 font-medium">{group.title}</p>
          <p className="text-xs text-gray-500 mt-0.5">{group.subtitle}</p>
        </div>
      </div>
      <div className="flex gap-2 overflow-x-auto pb-1">
        {group.tabs.map((tab) => {
          const active =
            location.pathname === tab.to ||
            (tab.to !== "/" && location.pathname.startsWith(`${tab.to}/`));
          return (
            <Link
              key={tab.key}
              to={tab.to}
              title={tab.hint}
              className={`shrink-0 px-3.5 py-1.5 rounded-full text-sm border transition ${
                active
                  ? "bg-stone-800 text-white border-stone-800"
                  : "bg-white text-stone-700 border-stone-200 hover:border-rose-300"
              }`}
            >
              {tab.label}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
